const form = {
  url: "https://docs.google.com/forms/d/e/1FAIpQLSenL161yoiq8EI-niuny-YoI8XzY_zI8vioNTLhIBCCQQU5qg/formResponse",
  method: "post",
};

export default form;
